var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecruit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "RecruitLogoWhiteText",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 371.7 45.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#758188;opacity:0.42;}.cls-3{fill:url(#RGF_Blue_Gradation_1);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "RGF_Blue_Gradation_1",
    x1: 0.31,
    y1: 15.21,
    x2: 32.18,
    y2: 30.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54c3f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#49baec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#219bdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0988d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0081cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0068b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#005bac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004ea2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company"
  }, /*#__PURE__*/React.createElement("path", {
    id: "r",
    className: "cls-1",
    d: "M225.6,42.8h-2.9c-.2,0-.3-.2-.4-.4l-3.4-6.2h-2.4v6.3a.4.4,0,0,1-.4.4h-2.3a.5.5,0,0,1-.5-.4v-16c0-.5.3-.6.8-.7a29,29,0,0,1,4.5-.3c3.6,0,6.7,1.3,6.7,5.2v.2a4.8,4.8,0,0,1-3.1,4.8l3.6,6.8C225.9,42.6,225.8,42.8,225.6,42.8Zm-3.5-12.2c0-1.7-1.2-2.5-3.5-2.5h-2.1v5.3h2.1c2.4,0,3.5-.6,3.5-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    className: "cls-1",
    d: "M238.1,37.3h-7.5c0,1.4.6,3,2.5,3l4.5-.2c.3,0,.5.1.5.3V42c0,.4,0,.5-.5.6a19.2,19.2,0,0,1-4.5.4c-2.5,0-5.6-1.2-5.6-5.8V35.5c0-3.7,2-5.9,5.6-5.9s5.5,2.4,5.5,5.9v1.3C238.6,37.1,238.5,37.3,238.1,37.3Zm-2.6-2.2c0-1.8-1-2.9-2.4-2.9s-2.5,1-2.5,2.9h4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    className: "cls-1",
    d: "M248.6,42.7a14.4,14.4,0,0,1-3,.3c-3,0-5.2-1.9-5.2-5.6V35.2c0-3.8,2.2-5.6,5.2-5.6a9.6,9.6,0,0,1,3,.3c.4.1.5.2.5.6V32c0,.2-.2.3-.5.3h-3c-1,0-2.2.6-2.2,3v2.2c0,2.4,1.2,3,2.2,3a11.9,11.9,0,0,0,3-.2c.3,0,.5.1.5.4v1.5C249.1,42.5,249,42.6,248.6,42.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r-2",
    "data-name": "r",
    className: "cls-1",
    d: "M257.6,32.2a6.9,6.9,0,0,0-3.2.8v9.3a.5.5,0,0,1-.5.5h-2.1a.5.5,0,0,1-.5-.5V30.2a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5v.5a5.2,5.2,0,0,1,3.3-1.1.5.5,0,0,1,.5.4v1.7A.5.5,0,0,1,257.6,32.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    className: "cls-1",
    d: "M270,42.8h-2.2a.4.4,0,0,1-.4-.4v-.6a6.1,6.1,0,0,1-3.7,1.2,3.7,3.7,0,0,1-2.8-1c-.9-.9-1.2-2.3-1.2-4.2V30.2a.5.5,0,0,1,.5-.5h2.1a.5.5,0,0,1,.5.5v7.6c0,1.1.1,1.8.5,2.2a1.8,1.8,0,0,0,1.4.4,7.8,7.8,0,0,0,2.7-.9V30.2c0-.2.2-.5.4-.5H270c.2,0,.4.3.4.5V42.4A.4.4,0,0,1,270,42.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    className: "cls-1",
    d: "M275.8,28h-2.2a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5h2.2a.5.5,0,0,1,.5.5v2A.5.5,0,0,1,275.8,28Zm0,14.8h-2.2a.5.5,0,0,1-.4-.5V30.2a.5.5,0,0,1,.4-.5h2.2a.5.5,0,0,1,.4.5V42.3A.5.5,0,0,1,275.8,42.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    className: "cls-1",
    d: "M285.9,42.8l-1.6.2c-2.6,0-3.7-.6-3.7-3.7V32l-2.2-.3c-.3-.1-.5-.2-.5-.5v-1a.5.5,0,0,1,.5-.5h2.2V27.8a.4.4,0,0,1,.4-.4l2.2-.4a.3.3,0,0,1,.5.3v2.4h2.1a.5.5,0,0,1,.4.5v1.4a.4.4,0,0,1-.4.4h-2.1v7.3c0,1.2,0,1.3.9,1.3h1.2c.3,0,.5.1.5.4v1.4C286.3,42.7,286.2,42.8,285.9,42.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c-2",
    "data-name": "c",
    className: "cls-1",
    d: "M304,42.6a17.1,17.1,0,0,1-3.7.4c-2.8,0-6.6-1.4-6.6-7.1V32.5c0-5.8,3.8-7.1,6.6-7.1s3.3.3,3.7.3a.6.6,0,0,1,.5.6v1.5c0,.3-.2.6-.5.5l-3.7-.2c-1.9,0-3.3,1.1-3.3,4.4v3.4c0,3.2,1.4,4.3,3.3,4.3H304c.3-.1.5.1.5.4v1.6C304.5,42.4,304.3,42.5,304,42.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    className: "cls-1",
    d: "M311.8,43c-3.6,0-5.5-2.5-5.5-5.8V35.3c0-3.3,1.9-5.7,5.5-5.7s5.6,2.4,5.6,5.7v1.9C317.4,40.5,315.5,43,311.8,43Zm2.5-7.7c0-1.9-.8-3.1-2.5-3.1s-2.4,1.2-2.4,3.1v1.9c0,1.9.8,3.2,2.4,3.2s2.5-1.3,2.5-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dot",
    className: "cls-1",
    d: "M322.2,42.8h-2.1a.4.4,0,0,1-.4-.4V39.7a.4.4,0,0,1,.4-.4h2.1a.5.5,0,0,1,.5.4v2.7A.5.5,0,0,1,322.2,42.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "comma",
    className: "cls-1",
    d: "M326.5,44.6c-.1.3-.2.5-.5.5h-1.6a.3.3,0,0,1-.3-.5l1.4-4.9c.1-.2.2-.4.5-.4h2.2c.3,0,.4.2.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    className: "cls-1",
    d: "M344.5,42.7l-3.9.3c-3,0-5.4-.8-5.4-4.8V26a.5.5,0,0,1,.5-.4H338c.2,0,.5.2.5.4V38.2c0,1.6.4,2,1.8,2h4.2a.5.5,0,0,1,.5.5v1.5C345,42.5,344.9,42.6,344.5,42.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t-2",
    "data-name": "t",
    className: "cls-1",
    d: "M353.5,42.8l-1.6.2c-2.6,0-3.7-.6-3.7-3.7V32l-2.1-.3a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h2.1V27.8a.5.5,0,0,1,.5-.4l2.2-.4c.2-.1.4.1.4.3v2.4h2.1a.5.5,0,0,1,.5.5v1.4a.5.5,0,0,1-.5.4h-2.1v7.3c0,1.2.1,1.3.9,1.3h1.3c.3,0,.4.1.4.4v1.4C353.9,42.7,353.8,42.8,353.5,42.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    className: "cls-1",
    d: "M365.4,42.4a17.6,17.6,0,0,1-4.6.6c-3.8,0-5.6-2.2-5.6-5.8V35.4c0-3.6,1.8-5.8,5.6-5.8H363V25.6a.5.5,0,0,1,.5-.5h2.1a.5.5,0,0,1,.5.5V41.8C366.1,42.1,366,42.3,365.4,42.4ZM363,32.2h-2.2c-2,0-2.5,1.4-2.5,3.3v1.8c0,1.9.5,3.3,2.5,3.3l2.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dot-2",
    "data-name": "dot",
    className: "cls-1",
    d: "M371.3,42.8h-2.1c-.2,0-.5-.2-.5-.4V39.7c0-.2.3-.4.5-.4h2.1a.4.4,0,0,1,.4.4v2.7A.4.4,0,0,1,371.3,42.8Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "parenthesis",
    className: "cls-1",
    d: "M185.1,42.9h-1.9a.6.6,0,0,1-.6-.3,13.3,13.3,0,0,1-2.5-8.4v-.4a13.3,13.3,0,0,1,2.5-8.4c.1-.3.3-.3.6-.3h1.9c.2,0,.3.1.3.2s-.1.2-.1.3a16.1,16.1,0,0,0-2.1,8.2v.4a16.1,16.1,0,0,0,2.1,8.2c0,.1.1.2.1.3S185.3,42.9,185.1,42.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c-3",
    "data-name": "c",
    className: "cls-1",
    d: "M195.8,41.1a12.8,12.8,0,0,1-2.8.3c-2.9,0-5.6-1.5-5.6-6.1V32.9c0-4.5,2.7-6,5.6-6a12.8,12.8,0,0,1,2.8.3c.3.1.4.2.4.5v1.8c0,.2-.1.4-.3.4h-.1l-2.8-.2c-1.3,0-2.3.7-2.3,3.2v2.4c0,2.6,1,3.2,2.3,3.2h2.9c.2,0,.3.1.3.4v1.8C196.2,40.9,196.1,41,195.8,41.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "parenthesis-2",
    "data-name": "parenthesis",
    className: "cls-1",
    d: "M201.9,42.6a.6.6,0,0,1-.6.3h-1.9c-.2,0-.2-.1-.2-.2a.4.4,0,0,1,.1-.3,17.3,17.3,0,0,0,2-8.2v-.4a17.3,17.3,0,0,0-2-8.2.4.4,0,0,1-.1-.3c0-.1,0-.2.2-.2h1.9c.3,0,.5,0,.6.3,1.7,2.2,2.5,4.7,2.5,8.4v.4C204.4,37.9,203.6,40.4,201.9,42.6Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shadow",
    className: "cls-2",
    d: "M37.3,18.1C7.4,14.2.4,39.5.4,40.4c0,3.9,10.7,4.4,11.5,0C14.3,27.5,21.3,20,35.8,20,37.9,20,37.7,18.2,37.3,18.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bridge",
    className: "cls-3",
    d: "M20.8,0C12,0,0,5.3,0,22.1V40.6c0,4.2,11.9,4.2,11.9,0V21.4c0-7.8,4.9-13.7,11.9-13.9,5.4-.1,9.9,2.7,9.9,10.6,0,2,3.9,2,3.9,0C37.6,4.7,30.2,0,20.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r-3",
    "data-name": "r",
    className: "cls-1",
    d: "M49.4,42.8H45.1a.7.7,0,0,1-.7-.5l-5.2-6.9H35.6v7c0,.3-.3.5-.7.5H31.4c-.4,0-.7-.2-.7-.5V24.5c0-.5.4-.6,1.1-.7a66,66,0,0,1,6.9-.4c5.5,0,10.3,1.5,10.3,5.9v.2c0,2.7-1.9,4.4-4.8,5.3l5.5,7.5C49.9,42.6,49.8,42.8,49.4,42.8ZM44.1,29.3c0-2-1.8-2.8-5.4-2.8H35.6v5.8h3.1c3.7,0,5.4-.7,5.4-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e-2",
    "data-name": "e",
    className: "cls-1",
    d: "M68.4,42.7a55.4,55.4,0,0,1-6.7.3c-4.6,0-8.2-.9-8.2-5.3v-9c0-4.4,3.6-5.3,8.2-5.3a46.6,46.6,0,0,1,6.7.4c.5.1.7.2.7.5V26c0,.3-.3.5-.7.5H61.2c-2.1,0-2.8.5-2.8,2.2v2.8H68c.4,0,.7.2.7.5v1.9c0,.3-.3.5-.7.5H58.4v3.3c0,1.7.7,2.3,2.8,2.3h7.2c.4,0,.7.2.7.5v1.6C69.1,42.5,68.9,42.6,68.4,42.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c-4",
    "data-name": "c",
    className: "cls-1",
    d: "M88.5,42.6a37.5,37.5,0,0,1-5.6.4c-4.3,0-10-1.5-10-7.9V31.3c0-6.4,5.7-7.9,10-7.9a24.5,24.5,0,0,1,5.6.5c.5.1.8.2.8.5v1.8c0,.3-.2.5-.8.5L83,26.5c-3,0-5.2,1.2-5.2,4.8v3.8C77.8,38.7,80,40,83,40l5.5-.3c.6,0,.8.3.8.6V42C89.3,42.4,89,42.5,88.5,42.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r-4",
    "data-name": "r",
    className: "cls-1",
    d: "M111.9,42.8h-4.3c-.4,0-.5-.2-.7-.5l-5.1-6.9H98.1v7c0,.3-.3.5-.7.5H93.9c-.4,0-.7-.2-.7-.5V24.5c0-.5.4-.6,1.1-.7a68.1,68.1,0,0,1,7-.4c5.4,0,10.2,1.5,10.2,5.9v.2c0,2.7-1.9,4.4-4.8,5.3l5.6,7.5C112.5,42.6,112.3,42.8,111.9,42.8Zm-5.3-13.5c0-2-1.8-2.8-5.3-2.8H98.1v5.8h3.2c3.6,0,5.3-.7,5.3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-2",
    "data-name": "u",
    className: "cls-1",
    d: "M132.9,42.6c-1.3.1-5.7.4-7.9.4-5.7,0-9.7-1.7-9.7-7.2V24.1a.7.7,0,0,1,.7-.5h3.5c.4,0,.8.3.8.5V35.8c0,2.9.9,4.3,4.7,4.3l4.9-.2V24.1a.7.7,0,0,1,.7-.5h3.5a.7.7,0,0,1,.7.5V41C134.8,42.1,134.2,42.5,132.9,42.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i-2",
    "data-name": "i",
    className: "cls-1",
    d: "M144,42.8h-3.5c-.4,0-.7-.2-.7-.5V24.1a.7.7,0,0,1,.7-.5H144a.7.7,0,0,1,.7.5V42.3C144.7,42.6,144.4,42.8,144,42.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t-3",
    "data-name": "t",
    className: "cls-1",
    d: "M166.1,26.6h-6.2V42.3c0,.3-.3.5-.7.5h-3.5c-.4,0-.7-.2-.7-.5V26.6h-6.2c-.4,0-.7-.1-.7-.4V24.1a.7.7,0,0,1,.7-.5h17.3a.7.7,0,0,1,.7.5v2.1C166.8,26.5,166.5,26.6,166.1,26.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruit);
export default __webpack_public_path__ + "static/media/recruit.2cfafc02ea210263386aa8addb8cb87e.svg";
export { ForwardRef as ReactComponent };